/** Who's signed in, shared by every page */
import { useEffect, useState } from 'preact/hooks';
import { api, type Me } from './api';

let me: Me | null = null;
let loading: Promise<Me> | null = null;
const listeners = new Set<(me: Me) => void>();

export function refreshMe() {
	loading = api.get<Me>('/api/me').then(result => {
		me = result;
		for (const listener of listeners) listener(result);
		return result;
	}).catch(() => {
		me = { user: null, discordSignIn: false };
		for (const listener of listeners) listener(me);
		return me;
	});
	return loading;
}

/** null until it's known */
export function useMe() {
	const [value, setValue] = useState(me);
	useEffect(() => {
		listeners.add(setValue);
		if (!loading) void refreshMe();
		return () => {
			listeners.delete(setValue);
		};
	}, []);
	return value;
}

export async function signOut() {
	await api.post('/api/auth/logout');
	await refreshMe();
}
